




















export default {
    name: 'CoScrollMarker',
    props: {
        offsetRight: {
            type: String,
            default: '0px',
        },
        offsetBottom: {
            type: String,
            default: '0px',
        },
        rootElementQuerySelector: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            observer: null,
        };
    },
    computed: {
        scrollMarkerOffset() {
            return `${this.offsetTop || '0px'} ${this.offsetRight || '0px'} ${this.offsetBottom || '0px'} ${
                this.offsetLeft || '0px'
            }`;
        },
    },
    mounted() {
        // Register IntersectionObserver
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) this.$emit('intersecting', { entry, observer: this.observer });
                });
            },
            {
                root: this.rootElementQuerySelector ? document.querySelector(this.rootElementQuerySelector) : document,
                // rootMargin: this.scrollMarkerOffset,
            }
        );
        // Declares what to observe, and observes its properties.
        this.observer.observe(this.$refs?.scrollMarker);
    },
};
